import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

const NotFoundPage = () => {
  const { t } = useTranslation();

  return (
    <div className="min-h-[60vh] flex flex-col items-center justify-center px-4 text-center">
      <div className="max-w-md mx-auto">
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-gray-200">404</h1>
        </div>
        
        <h2 className="text-3xl font-bold text-gray-900 mb-4">
          {t('404.title', 'Page Not Found')}
        </h2>
        
        <p className="text-gray-600 mb-8 leading-relaxed">
          {t('404.message', 'Sorry, the page you are looking for could not be found. It might have been moved, deleted, or you entered the wrong URL.')}
        </p>
        
        <div className="space-y-4 sm:space-y-0 sm:space-x-4 sm:flex sm:justify-center">
          <Link 
            to="/"
            className="inline-block px-6 py-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-colors duration-200"
          >
            {t('404.goHome', 'Go Home')}
          </Link>
          
          <Link 
            to="/products"
            className="inline-block px-6 py-3 bg-gray-100 text-gray-700 font-medium rounded-lg hover:bg-gray-200 transition-colors duration-200"
          >
            {t('404.browseProducts', 'Browse Products')}
          </Link>
        </div>
        
        <div className="mt-12 text-sm text-gray-500">
          <p>{t('404.help', 'Need help? Contact our support team.')}</p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;